var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.492 1.66675H6.50866C3.47533 1.66675 1.66699 3.47508 1.66699 6.50841V13.4834C1.66699 16.5251 3.47533 18.3334 6.50866 18.3334H13.4837C16.517 18.3334 18.3253 16.5251 18.3253 13.4917V6.50841C18.3337 3.47508 16.5253 1.66675 13.492 1.66675Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0249 7.84173C13.9665 7.70007 13.8499 7.5834 13.7082 7.52507C13.6415 7.50007 13.5665 7.4834 13.4915 7.4834H11.9415C11.6165 7.4834 11.3582 7.74173 11.3582 8.06673C11.3582 8.39173 11.6165 8.65007 11.9415 8.65007H12.0915L10.3332 10.4084L9.4832 9.14173C9.3832 9.00007 9.2332 8.90007 9.0582 8.8834C8.87487 8.86673 8.71654 8.92507 8.59154 9.05007L6.1082 11.5334C5.8832 11.7584 5.8832 12.1251 6.1082 12.3584C6.22487 12.4751 6.36654 12.5251 6.51654 12.5251C6.66654 12.5251 6.81654 12.4667 6.92487 12.3584L8.9082 10.3751L9.7582 11.6417C9.8582 11.7834 10.0082 11.8834 10.1832 11.9001C10.3665 11.9167 10.5249 11.8584 10.6499 11.7334L12.9165 9.46673V9.61673C12.9165 9.94173 13.1749 10.2001 13.4999 10.2001C13.8249 10.2001 14.0832 9.94173 14.0832 9.61673V8.0584C14.0665 7.9834 14.0582 7.9084 14.0249 7.84173Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.9a7b79d071c9344342809bf38d564a55.svg";
export { ForwardRef as ReactComponent };